import { appendReduxPart } from "infrastructure/store";

import { SecurityRolesFilter } from "./components";
import SecurityRoles from "./SecurityRoles";
import { securityRolesSaga } from "./SecurityRoles.saga";
import { securityRoles } from "./SecurityRoles.slice";

export * from "./SecurityRoles.actions";
export * from "./SecurityRoles.state";

export { SecurityRoles, SecurityRolesFilter };

appendReduxPart(
  {
    reducerName: securityRoles.name,
    reducer: securityRoles.reducer
  },
  securityRolesSaga()
);
